import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";

// Curated payout & bank partners — displayed as clean wordmarks
const PARTNERS = [
  { name: "M-Pesa", tag: "MOBILE MONEY", kind: "wallet" },
  { name: "MTN MoMo", tag: "MOBILE MONEY", kind: "wallet" },
  { name: "GTBank", tag: "BANK", kind: "bank" },
  { name: "Wave", tag: "MOBILE MONEY", kind: "wallet" },
  { name: "Equity Bank", tag: "BANK", kind: "bank" },
  { name: "Orange Money", tag: "MOBILE MONEY", kind: "wallet" },
  { name: "Airtel Money", tag: "MOBILE MONEY", kind: "wallet" },
  { name: "Access Bank", tag: "BANK", kind: "bank" },
  { name: "KCB", tag: "BANK", kind: "bank" },
  { name: "Zenith Bank", tag: "BANK", kind: "bank" },
  { name: "PalmPay", tag: "WALLET", kind: "wallet" },
  { name: "Chipper", tag: "WALLET", kind: "wallet" },
  { name: "Telebirr", tag: "MOBILE MONEY", kind: "wallet" },
];

export default function TrustRow() {
  const { t } = useTranslation();
  return (
    <section className="py-16 md:py-20 bg-canvas border-b border-forest/8" data-testid="trust-row">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="shrink-0 md:max-w-[260px]">
            <div className="label-eyebrow">{t("home.trust.eyebrow")}</div>
            <div className="mt-2 text-ink/70 text-sm leading-relaxed">
              {t("home.trust.body")}
            </div>
          </div>
          <div className="flex-1 edge-fade marquee-strip">
            <Marquee gradient={false} speed={32} pauseOnHover>
              {PARTNERS.map((p, i) => (
                <div
                  key={`${p.name}-${i}`}
                  className="inline-flex items-center gap-3 pr-10"
                  data-testid={`partner-${p.name.toLowerCase().replace(/\s|-/g, "")}`}
                >
                  <PartnerBadge kind={p.kind} />
                  <div className="flex flex-col leading-none">
                    <span className="font-display font-medium text-forest text-2xl md:text-3xl tracking-tight">
                      {p.name}
                    </span>
                    <span className="mt-1 text-[9px] tracking-[0.22em] uppercase text-ink/45 font-semibold">
                      {p.tag}
                    </span>
                  </div>
                </div>
              ))}
            </Marquee>
          </div>
        </div>
      </div>
    </section>
  );
}

function PartnerBadge({ kind }) {
  // Distinct 32px monogram — bank vs wallet
  if (kind === "bank") {
    return (
      <div className="w-10 h-10 rounded-xl bg-forest text-canvas grid place-items-center shrink-0">
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
          <path d="M2 8 L10 3 L18 8 M3 8 L3 16 M17 8 L17 16 M6 10 L6 15 M10 10 L10 15 M14 10 L14 15 M2 17 L18 17" stroke="#E8FF00" strokeWidth="1.5" strokeLinecap="square"/>
        </svg>
      </div>
    );
  }
  return (
    <div className="w-10 h-10 rounded-xl bg-forest text-canvas grid place-items-center shrink-0 relative overflow-hidden">
      <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
        <rect x="3" y="6" width="14" height="10" rx="2" stroke="#E8FF00" strokeWidth="1.5"/>
        <path d="M3 10 h14" stroke="#E8FF00" strokeWidth="1.5"/>
        <circle cx="14" cy="13" r="1.2" fill="#E8FF00"/>
      </svg>
    </div>
  );
}
